import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { FiPhone, FiMail, FiMapPin, FiSend, FiUser, FiMessageSquare } from 'react-icons/fi';
import apiInstance from '../../utils/axios';

function Contact() {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [storeInfo, setStoreInfo] = useState({ whatsapp: '', phones: [], emails: [] });

  useEffect(() => {
    const fetchStoreInfo = async () => {
      try {
        const response = await apiInstance.get('store-info/');
        setStoreInfo(prev => ({ ...prev, ...response.data }));
      } catch (error) {
        console.log('Using default contact info');
      }
    };
    fetchStoreInfo();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    // Simulate form submission
    await new Promise(resolve => setTimeout(resolve, 1000));
    setSubmitted(true);
    setSubmitting(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const openWhatsApp = (phone) => {
    const message = encodeURIComponent('¡Hola! Vi su tienda ASMAR SHOP.');
    window.location.href = `https://wa.me/${phone.replace(/[^0-9]/g, '')}?text=${message}`;
  };

  const contactInfo = [
    { icon: FiPhone, label: t('phone'), value: storeInfo.phones?.[0] || '' },
    { icon: FiMail, label: t('email'), value: storeInfo.emails?.[0] || 'contato@asmarshop.com.br' },
    { icon: FiMapPin, label: t('address') || 'Dirección', value: storeInfo.address || 'Asunción, Paraguay' },
  ];

  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
        padding: '80px 20px',
        textAlign: 'center',
      }}>
        <div style={{
          width: '64px',
          height: '64px',
          borderRadius: '16px',
          backgroundColor: 'rgba(59, 130, 246, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px',
        }}>
          <FiMessageSquare size={28} color="#3b82f6" />
        </div>
        <h1 style={{
          fontSize: '36px',
          fontWeight: '700',
          color: 'white',
          marginBottom: '16px',
        }}>
          {t('contactUs')}
        </h1>
        <p style={{
          fontSize: '18px',
          color: '#94a3b8',
          maxWidth: '500px',
          margin: '0 auto',
        }}>
          {t('contactDirectly')}
        </p>
      </div>

      {/* Main Content */}
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '60px 20px',
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '40px',
        }}>
          {/* Contact Form */}
          <div style={{
            backgroundColor: 'white',
            borderRadius: '24px',
            padding: '40px',
            boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
          }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '700',
              color: '#1f2937',
              marginBottom: '32px',
            }}>
              {t('sendMessage')}
            </h2>

            {submitted ? (
              <div style={{
                textAlign: 'center',
                padding: '40px 20px',
              }}>
                <div style={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '50%',
                  backgroundColor: '#dcfce7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                }}>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                    <path d="M5 13L9 17L19 7" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3 style={{ fontSize: '20px', fontWeight: '600', color: '#1f2937', marginBottom: '8px' }}>
                  {t('success')}!
                </h3>
                <p style={{ color: '#6b7280' }}>
                  Recebemos sua mensagem. Entraremos em contato em breve!
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                {[
                  { name: 'name', label: t('yourName'), icon: FiUser, type: 'text' },
                  { name: 'email', label: t('yourEmail'), icon: FiMail, type: 'email' },
                  { name: 'subject', label: t('subject'), icon: FiMessageSquare, type: 'text' },
                ].map((field) => (
                  <div key={field.name} style={{ marginBottom: '20px' }}>
                    <label style={{
                      display: 'block',
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#374151',
                      marginBottom: '8px',
                    }}>
                      {field.label}
                    </label>
                    <div style={{ position: 'relative' }}>
                      <div style={{
                        position: 'absolute',
                        left: '16px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: '#9ca3af',
                      }}>
                        <field.icon size={20} />
                      </div>
                      <input
                        type={field.type}
                        name={field.name}
                        value={formData[field.name]}
                        onChange={handleChange}
                        required
                        style={{
                          width: '100%',
                          padding: '16px 16px 16px 48px',
                          fontSize: '16px',
                          borderRadius: '14px',
                          border: '2px solid #e5e7eb',
                          outline: 'none',
                          transition: 'all 0.2s ease',
                          boxSizing: 'border-box',
                        }}
                        onFocus={(e) => {
                          e.currentTarget.style.borderColor = '#3b82f6';
                          e.currentTarget.style.boxShadow = '0 0 0 4px rgba(59, 130, 246, 0.1)';
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.borderColor = '#e5e7eb';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      />
                    </div>
                  </div>
                ))}

                <div style={{ marginBottom: '24px' }}>
                  <label style={{
                    display: 'block',
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '8px',
                  }}>
                    {t('message')}
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={5}
                    style={{
                      width: '100%',
                      padding: '16px',
                      fontSize: '16px',
                      borderRadius: '14px',
                      border: '2px solid #e5e7eb',
                      outline: 'none',
                      resize: 'vertical',
                      transition: 'all 0.2s ease',
                      boxSizing: 'border-box',
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.borderColor = '#3b82f6';
                      e.currentTarget.style.boxShadow = '0 0 0 4px rgba(59, 130, 246, 0.1)';
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = '#e5e7eb';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <button
                  type="submit"
                  disabled={submitting}
                  style={{
                    width: '100%',
                    padding: '16px',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: 'white',
                    backgroundColor: submitting ? '#93c5fd' : '#3b82f6',
                    border: 'none',
                    borderRadius: '14px',
                    cursor: submitting ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    if (!submitting) e.currentTarget.style.backgroundColor = '#2563eb';
                  }}
                  onMouseLeave={(e) => {
                    if (!submitting) e.currentTarget.style.backgroundColor = '#3b82f6';
                  }}
                >
                  {submitting ? (
                    <>
                      <div style={{
                        width: '20px',
                        height: '20px',
                        border: '2px solid rgba(255,255,255,0.3)',
                        borderTopColor: 'white',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                      }} />
                      {t('processing')}
                    </>
                  ) : (
                    <>
                      <FiSend size={20} />
                      {t('send')}
                    </>
                  )}
                </button>
              </form>
            )}
          </div>

          {/* Contact Info */}
          <div>
            {/* Contact Cards */}
            <div style={{
              backgroundColor: 'white',
              borderRadius: '24px',
              padding: '40px',
              boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
              marginBottom: '24px',
            }}>
              <h2 style={{
                fontSize: '22px',
                fontWeight: '700',
                color: '#1f2937',
                marginBottom: '32px',
              }}>
                {t('contactInfo')}
              </h2>

              {contactInfo.map((info, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    padding: '16px 0',
                    borderBottom: index < contactInfo.length - 1 ? '1px solid #f3f4f6' : 'none',
                  }}
                >
                  <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    backgroundColor: '#f0f9ff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}>
                    <info.icon size={22} color="#3b82f6" />
                  </div>
                  <div>
                    <p style={{
                      fontSize: '13px',
                      color: '#6b7280',
                      marginBottom: '4px',
                    }}>
                      {info.label}
                    </p>
                    <p style={{
                      fontSize: '15px',
                      fontWeight: '600',
                      color: '#1f2937',
                      margin: 0,
                    }}>
                      {info.value}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* WhatsApp Card */}
            <div style={{
              backgroundColor: '#dcfce7',
              borderRadius: '24px',
              padding: '32px',
              textAlign: 'center',
            }}>
              <div style={{
                width: '56px',
                height: '56px',
                borderRadius: '50%',
                backgroundColor: '#22c55e',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
              }}>
                <i className="fab fa-whatsapp" style={{ fontSize: '28px', color: 'white' }}></i>
              </div>
              <h3 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#166534',
                marginBottom: '8px',
              }}>
                WhatsApp 24/7
              </h3>
              <p style={{
                color: '#15803d',
                fontSize: '14px',
                marginBottom: '20px',
              }}>
                Atendimento rápido pelo WhatsApp
              </p>
              <button
                onClick={() => openWhatsApp(storeInfo.whatsapp)}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '14px 28px',
                  borderRadius: '14px',
                  border: 'none',
                  backgroundColor: '#22c55e',
                  color: 'white',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#16a34a';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#22c55e';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <i className="fab fa-whatsapp" style={{ fontSize: '20px' }}></i>
                {t('writeWhatsApp')}
              </button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default Contact;
